import { IconTrash } from "app/components/Icon/Icon";
import isPublicView from "app/utils/publicViewUtils";
import ENV from "config";
import { FormattedMessage } from "react-intl";
import "./BetslipButtons.scss";

type Props = {
  isSubmitDisabled: boolean;
  submitBet: (ev: React.MouseEvent<HTMLButtonElement>) => void;
  showAcceptOddsText: boolean;
  removeBet: () => void;
};

const BetslipButtons: React.FC<Props> = ({
  isSubmitDisabled,
  submitBet,
  showAcceptOddsText,
  removeBet,
}) => {
  return (
    <div>
      <div className="betslip-buttons">
        <button
          type="submit"
          className="betslip-buttons__submit-button"
          disabled={isSubmitDisabled}
          onClick={(ev: React.MouseEvent<HTMLButtonElement>) => {
            if (isPublicView()) {
              // redirect to login page of customer site
              return window.location.replace(ENV.MAIN_SITE_URL + "/login");
            }
            return submitBet(ev);
          }}
        >
          {showAcceptOddsText ? (
            <FormattedMessage
              tagName="span"
              id={`${
                isPublicView() ? "public-view-place-bet" : "accept-&-place-bet"
              }`}
            />
          ) : (
            <FormattedMessage
              tagName="span"
              id={`${isPublicView() ? "public-view-place-bet" : "place-bet"}`}
            />
          )}
        </button>
        <button onClick={removeBet} className="betslip-buttons__remove-button">
          <IconTrash />
        </button>
      </div>
    </div>
  );
};

export default BetslipButtons;
